<template>
  <qx-card-form title="收入信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="split1"></section>
      <section slot="split2"></section>
      <section slot="split3"></section>
      <section slot="crossDistrictIncomeList" slot-scope="prop">
        <section>
          <CrossDistrictItem
            v-for="(item, index) in prop.form.crossDistrictIncomeList"
            :key="index"
            :index="index"
            :cclaId="item.cclaId"
            :lineId="item.lineId"
            :desProvince="item.desProvince"
            :desProvinceName="item.desProvinceName"
            :desCity="item.desCity"
            :desCityName="item.desCityName"
            :desCounty="item.desCounty"
            :desCountyName="item.desCountyName"
            :superzoneFee="item.superzoneFee"
            v-model="item.superzoneFee"
            @handleDeleteItem="handleDeleteItem"
          />
        </section>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  selectSysStaticDataByCodeType,
} from 'api';
import CrossDistrictItem from './components/crossDistrict';
export default {
  components: {
    CrossDistrictItem,
  },
  data () {
    return {
      // 所有省市区
      addressList: [],
      baseForm: {
        crossDistrictIncomeOptions: [],
        incomeChargeModeOptions: [],
        inline: true,
        form: [
          {
            label: '计费方式',
            value: 'incomeChargeMode',
            placeholder: '请选择计费方式',
            type: 'radio',
            default: '0',
            onChange: () => {
              this.handleChangeIncomeChargeMode();
            },
          },
          {
            value: 'split1',
            allCustom: true,
          },
          {
            label: '基本运费',
            value: 'incomeBasicShow',
            placeholder: '请输入基本运费',
            type: 'input',
            unit: '元',
          },
          {
            label: '基本运费',
            value: 'incomeBasic',
            placeholder: '请输入基本运费',
            type: 'input',
            hide: true,
          },
          {
            label: '基本点数',
            value: 'incomeBasicCount',
            placeholder: '请输入基本点数',
            type: 'input',
            remark: '基本运费包含配送点的个数',
            onBlur: () => {
              const incomeBasicCount = this.$refs.baseForm.getVal('incomeBasicCount');
              this.$emit('copyValueToOutwardCar', {
                incomeBasicCount,
              });
            },
          },
          {
            label: '点费',
            value: 'incomeRegionalCostShow',
            placeholder: '请输入点费',
            type: 'input',
            unit: '元/个',
            remark: '超出基本点数后按超出个数收费',
          },
          {
            label: '点费',
            value: 'incomeRegionalCost',
            placeholder: '请输入点费',
            type: 'input',
            hide: true,
          },
          {
            value: 'split2',
            allCustom: true,
          },
          {
            label: '超区区县',
            value: 'crossDistrictIncome',
            placeholder: '请选择超区区县',
            type: 'cascader',
            props: { multiple: true },
            collapseTags: true,
            onChange: (data) => {
              this.handleUnselectedChange(true);
            },
            hide: true,
          },
          {
            label: '基本里程',
            value: 'incomeMileageBasic',
            placeholder: '请输入基本里程',
            type: 'input',
            unit: '公里',
            remark: '基本运费包含里程',
            hide: true,
          },
          {
            label: '单公里运费',
            value: 'incomeMileageSinglekmShow',
            placeholder: '请输入单公里运费',
            type: 'input',
            hide: true,
          },
          {
            label: '单公里运费',
            value: 'incomeMileageSinglekm',
            type: 'input',
            hide: true,
          },
          {
            value: 'split3',
            allCustom: true,
          },
          {
            value: 'crossDistrictIncomeList',
            slot: true,
            default: [],
          },
        ],
        rules: {
          incomeChargeMode: [
            { required: true, message: '请选择计费方式', trigger: 'submit' },
          ],
          incomeBasicShow: [
            { required: true, message: '请输入基本运费', trigger: 'submit' },
          ],
          incomeBasicCount: [
            { required: true, message: '请输入基本点数', trigger: 'submit' },
          ],
          incomeRegionalCostShow: [
            { required: true, message: '请输入点数', trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {
    async getOptions () {
      if (!this.baseForm.incomeChargeModeOptions.length) {
        const incomeChargeModeOptions = await selectSysStaticDataByCodeType({
          codeType: 'CITY_LINE_CHARGR_MODE',
          hasAll: true,
        });
        this.baseForm.incomeChargeModeOptions = incomeChargeModeOptions.filter((item) => item.value !== '-1');
      }
    },

    // 获取所有的省市区
    setAddressInfo (data) {
      this.addressList = data;
    },

    // 获取超区区县列表
    getCrossDistrictInfo (crossDistrictIncome) {
      let crossDistrictInfo = {};
      for (let province of this.addressList) {
        for (let city of province.children) {
          if (city.value === crossDistrictIncome[0]) {
            for (let district of city.children) {
              if (district.value === crossDistrictIncome[1]) {
                crossDistrictInfo = {
                  lineType: 1,
                  desProvince: province.value,
                  desProvinceName: province.label,
                  desCity: city.value,
                  desCityName: city.label,
                  desCounty: district.value,
                  desCountyName: district.label,
                  superzoneFee: '',
                };
              }
            }
          }
        }
      }

      const crossDistrictIncomeList = this.$refs.baseForm.getVal('crossDistrictIncomeList');

      // 这里主要是为了让各个项塞进去 id 和 超区费用
      if (crossDistrictIncomeList.length) {
        for (let item of crossDistrictIncomeList) {
          if (
            item.desProvince === crossDistrictInfo.desProvince &&
            item.desCity === crossDistrictInfo.desCity &&
            item.desCounty === crossDistrictInfo.desCounty
          ) {
            crossDistrictInfo.cclaId = item.cclaId;
            crossDistrictInfo.lineId = item.lineId;
            crossDistrictInfo.customerId = item.customerId;
            crossDistrictInfo.superzoneFee = item.superzoneFee + '';
          }
        }
      }
      return crossDistrictInfo;
    },

    // 设置未选择区县
    setUnSelectDistrict (data) {
      setTimeout(() => {
        this.baseForm.crossDistrictIncomeOptions = data;
      }, 50);
    },

    // 选择超区区县
    handleUnselectedChange (isSync) {
      const crossDistrictIncome = this.$refs.baseForm.getVal('crossDistrictIncome');
      const newIncomeList = [];
      if (crossDistrictIncome) {
        for (let item of crossDistrictIncome) {
          const crossDistrictInfo = this.getCrossDistrictInfo(item);
          newIncomeList.push(crossDistrictInfo);
        }
      }
      this.$refs.baseForm.setVal('crossDistrictIncomeList', newIncomeList);
      // 把收入信息中的内容覆盖到成本信息中
      if (isSync) {
        this.$emit('copyValueToOutwardCar', {
          crossDistrictIncome,
          crossDistrictIncomeList: newIncomeList,
        });
      }
    },

    // 选择计费方式
    handleChangeIncomeChargeMode () {
      const incomeChargeMode = this.$refs.baseForm.getVal('incomeChargeMode');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['crossDistrictIncome', 'crossDistrictIncomeList', 'incomeMileageBasic', 'incomeMileageSinglekmShow'],
      });
      if (Number(incomeChargeMode) === 0) {
        // 按点位，显示超区县区
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['crossDistrictIncome', 'crossDistrictIncomeList'],
        });
      } else if (Number(incomeChargeMode) === 1) {
        // 按里程，显示 基本里程 和 单公里运费
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['incomeMileageBasic', 'incomeMileageSinglekmShow'],
        });
      }
    },

    // 删除该选项
    handleDeleteItem (index) {
      const crossDistrictIncome = this.$refs.baseForm.getVal('crossDistrictIncome');
      crossDistrictIncome.splice(index, 1);
      this.$refs.baseForm.setVal('crossDistrictIncome', crossDistrictIncome);
      this.handleUnselectedChange();
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.crossDistrictIncome;
      }
      console.log(formData);
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        const newFormData = {
          incomeChargeMode: formData.incomeChargeMode,
          incomeBasic: `${((formData.incomeBasicShow * 1000) / 10)}`,
          incomeRegionalCost: `${((formData.incomeRegionalCostShow * 1000) / 10)}`,
          incomeBasicCount: formData.incomeBasicCount,
          crossDistrictIncome: formData.crossDistrictIncome,
          incomeMileageBasic: formData.incomeMileageBasic,
          crossDistrictIncomeList: JSON.stringify(formData.crossDistrictIncomeList || []),
        };
        if (Number(formData.incomeChargeMode) === 1) {
          newFormData.incomeMileageSinglekm = `${(formData.incomeMileageSinglekmShow * 1000) / 10}`;
        }
        formData = newFormData;
      }
      return formData;
    },
    async init (data = {}) {

      await this.getOptions();

      if (data.incomeChargeMode === undefined) {
        data.incomeChargeMode = '0';
      } else {
        data.incomeChargeMode = String(data.incomeChargeMode);
      }

      if (data.incomeBasic) {
        data.incomeBasicShow = (data.incomeBasic) / 100;
      }

      if (data.incomeRegionalCost) {
        data.incomeRegionalCostShow = (data.incomeRegionalCost) / 100;
      }

      if (data.incomeMileageSinglekm) {
        data.incomeMileageSinglekmShow = (data.incomeMileageSinglekm) / 100;
      }

      if (data.subLinaArea && data.subLinaArea.length) {
        const crossDistrictIncome = [];
        const crossDistrictIncomeList = [];
        for (let item of data.subLinaArea) {
          if (item.lineType === 1) {
            crossDistrictIncome.push([item.desCity, item.desCounty]);
            crossDistrictIncomeList.push(item);
          }
        }
        data.crossDistrictIncome = crossDistrictIncome;
        data.crossDistrictIncomeList = crossDistrictIncomeList;
      } else {
        if (typeof data.crossDistrictIncomeList === 'string') {
          data.crossDistrictIncomeList = JSON.parse(data.crossDistrictIncomeList);
        }
      }

      this.$refs.baseForm.setVal(data);
      this.handleChangeIncomeChargeMode();
      this.handleUnselectedChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
